import React from 'react';
import { MediaPlaceholder } from './MediaPlaceholder';
import { CtaButton } from './CtaButton';
import { ShieldCheck, Lock, CreditCard, Users, Zap } from 'lucide-react';
const badges = [{
  icon: ShieldCheck,
  label: 'Garantía 7 días'
}, {
  icon: Lock,
  label: 'Pago seguro'
}, {
  icon: CreditCard,
  label: 'Mercado Pago'
}, {
  icon: Users,
  label: '+3.597 Alumnas'
}, {
  icon: Zap,
  label: 'Acceso en 5 minutos'
}];
export function HeroSection() {
  return <section className="px-6 pt-6 pb-12 flex flex-col items-center text-center relative z-10 max-w-7xl mx-auto" data-id="element-74">
      {/* Students proof image (stars + avatars) */}
      

      {/* Hero Title */}
      <div className="w-full mb-10 max-w-5xl flex flex-col items-center" data-id="element-75">
        {/* Discount Badge */}
        <div className="bg-[#9b26b2] text-white font-black text-[10px] md:text-sm px-6 py-2 rounded-full mb-8 shadow-[0_0_15px_rgba(34,197,94,0.6)] border border-green-400/30 uppercase tracking-widest" data-id="element-76">
          50% OFF - CUPOS LIMITADOS
        </div>

        <h1 className="text-brand-navy font-black leading-[1.1] mb-6 tracking-tight uppercase" style={{
        fontFamily: "'Inter', sans-serif",
        fontSize: '32px',
        fontWeight: 900
      }} data-id="element-77">
          ✨APRENDÉ A CREAR <span className="text-[#facc15]" data-id="element-78">VIDEOS UGC</span> Y
          TRABAJA CON LAS <span className="text-[#facc15]" data-id="element-79">MARCAS</span> DESDE
          CASA💸
        </h1>

        <p className="text-[#d946ef] font-black text-lg md:text-2xl uppercase tracking-tight" data-id="element-80">
          Sin experiencia ni seguidores. <br className="md:hidden" data-id="element-81" /> Con
          consultorías y acompañamiento ✅
        </p>
      </div>

      {/* Initial Video */}
      <div className="w-full mb-8 relative max-w-5xl" data-id="element-82">
        <div className="absolute -inset-2 bg-gradient-to-tr from-brand-pink to-brand-lavender rounded-3xl blur-lg opacity-50" data-id="element-83"></div>
        <div className="relative w-full aspect-video rounded-2xl overflow-hidden shadow-xl bg-black z-10" data-id="element-84">
          <iframe src="https://player.vimeo.com/video/1200659338?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" className="absolute top-0 left-0 w-full h-full" title="formula_creadora_de_contenido_ugc_v3 (1080p)" data-id="element-85"></iframe>
        </div>
      </div>

      {/* Copy */}
      <p className="text-brand-navy font-medium text-lg md:text-3xl leading-relaxed mb-6 px-1 max-w-4xl" data-id="element-86">
        Con mi método paso a paso, dejá de improvisar y empezá a{' '}
        <strong className="font-bold" data-id="element-87">generar +150 usd</strong> por cada video
        UGC como una <strong className="font-bold" data-id="element-88">Creadora PRO</strong> 💸✨
      </p>

      {/* Students count */}
      <p className="text-brand-navy font-semibold mb-6 md:text-2xl" data-id="element-89">
        +3.597 Alumnas UGC ⭐⭐⭐⭐⭐
      </p>

      {/* CTA */}
      <div className="md:scale-125 md:my-8" data-id="element-90">
        <CtaButton variant="gold" data-id="element-91">¡SI, QUIERO INSCRIBIRME!</CtaButton>
      </div>

      {/* Trust badges */}
      <div className="flex flex-wrap justify-center gap-x-3 md:gap-x-12 gap-y-2 mt-5 px-2" data-id="element-92">
        {badges.map(({
        icon: Icon,
        label
      }) => <span key={label} className="flex items-center gap-1 text-[11px] md:text-base font-medium text-brand-navy/80" data-id="element-93">
            <Icon size={13} className="text-brand-pinkDark md:scale-150" data-id="element-94" />
            {label}
          </span>)}
      </div>
    </section>;
}